import { BrowserRouter, Routes, Route } from "react-router-dom"
import PageAcceuil from "./components/PageAcceuil"
import MgLabo from "./components/MGLabo"
import MgCaisse from "./components/MgCaisse"
import socketIO from 'socket.io-client';
import Filtre from "./components/Filtre"
import MgTasks from './components/MgTasks';
import AdminPanel from './components/AdminPanel';
// Nouveaux imports
import MgStock from './components/MgStock';

const SOCKET_URL = window.location.origin;

console.log('🔌 Connexion Socket.IO à:', SOCKET_URL);

const socket = socketIO.connect(SOCKET_URL, {
    transports: ['websocket', 'polling'],
    timeout: 10000,
    path: '/socket.io',
    secure: window.location.protocol === 'https:'
});

function App() {
  return (
    <BrowserRouter basename="/">
      <div>
        <Routes>
          <Route path="/" element={<PageAcceuil socket={socket} />}></Route>
          <Route path="/AdminPanel" element={<AdminPanel socket={socket} />}></Route>
          <Route path="/PageAcceuil" element={<PageAcceuil socket={socket} />}></Route>
          <Route path="/MgLabo" element={<MgLabo socket={socket} />}></Route>
          <Route path="/MgCaisse" element={<MgCaisse socket={socket} />}></Route>
          <Route path="/MgStock" element={<MgStock socket={socket} />}></Route>
          <Route path="/MgTasks" element={<MgTasks socket={socket} />} />
          <Route path="/Filtre" element={<Filtre socket={socket} />}></Route>
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
